<template>
  <div>
    <b-row style="margin-bottom: 2rem">
      <b-col cols="12" class="back-list">
        <router-link :to="{ name: 'dictionary_words_path', params: { dictionary_id: id } }" >
          <i class="fas fa-arrow-left"></i>
          <span>{{ $t('views.dictionary_words.back_list') }}</span>
        </router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="8">
        <div class="form-container separator">
          <pcg-text-input class="col-12"
                          :label="$t('views.dictionary_words.labels.key')"
                          :error-text="getError('key')"
                          :show-error="errorExist('key')"
                          v-model="dictionaryWord.key"/>
          <pcg-text-input class="col-12"
                          :label="$t('views.dictionary_words.labels.value')"
                          :error-text="getError('value')"
                          :show-error="errorExist('value')"
                          v-model="dictionaryWord.value"/>
          <pcg-text-input class="col-12"
                          :label="$t('views.dictionary_words.labels.lang')"
                          :error-text="getError('lang')"
                          :show-error="errorExist('lang')"
                          v-model="dictionaryWord.lang"
                          v-if="dictionary.key === 'keywords'"/>
<!--          <pcg-text-input class="col-12"-->
<!--                          :label="$t('views.dictionary_words.labels.valueEn')"-->
<!--                          :error-text="getError('valueEn')"-->
<!--                          :show-error="errorExist('valueEn')"-->
<!--                          v-model="dictionaryWord.valueEn"/>-->
          <pcg-checkbox class="col-12"
                        :error-text="getError('status')"
                        :show-error="errorExist('status')"
                        v-model="dictionaryWord.statusBoolean">
            {{$t('views.dictionary_words.labels.accept')}}
          </pcg-checkbox>

          <pcg-btn v-if="dictionaryWord" size="small" @click="createDictionaryWord()" variant="additional" class="action-btn">
            {{ $t('views.common.save') }}
          </pcg-btn>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import ApiDictionaryWords from '../../api/dictionary_words'
import ApiDictionary from '../../api/dictionaries'

export default {
  name: 'DictionaryWordsNew',
  components: {
  },
  data () {
    return {
      academyId: this.$route.query.academy_id,
      dictionaryId: this.$route.params.dictionaryId,
      id: this.$route.params.id,
      errors: {},
      dictionary: {},
      dictionaryWord: {
        key: null,
        lang: null,
        value: null,
        valueEn: null,
        status: null,
        statusBoolean: null
      }
    }
  },
  mounted () {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    // this.getDictionaryWord()
    this.getDictionary()
    return true
  },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.dictionary_words.new.title'),
        subtitle: this.$t('views.dictionary_words.new.subtitle'),
        capitalizeSubtitle: false
      })
    },
    createDictionaryWord () {
      this.loading = true
      this.dictionaryWord.valueEn = this.dictionaryWord.value
      const dictionaryWordDup = this.dictionaryWord
      if (this.dictionaryWord.statusBoolean) {
        dictionaryWordDup.status = 'accepted'
      } else {
        dictionaryWordDup.status = 'rejected'
      }
      dictionaryWordDup.academy_id = this.academyId
      ApiDictionaryWords.createDictionaryWord(this.dictionaryId, { dictionaryWord: dictionaryWordDup })
        .then(response => {
          this.errors = {}
          this.$router.push({
            name: 'dictionary_words_edit_path',
            params: { dictionaryId: response.data.data.attributes.dictionaryId, id: response.data.data.id }
          })
          setTimeout(() => { this.$toastr.s(this.$t('general.dictionary_word_updated')) }, 1)
        }).catch(error => {
          this.errors = error.response.data
          setTimeout(() => { this.$toastr.e(this.$t('general.check_errors')) }, 1)
        }).finally(() => {
          this.loading = false
        })
    },
    getDictionary () {
      ApiDictionary.getDictionary(this.dictionaryId)
        .then(result => {
          this.dictionary = result.data.data.attributes
        })
    },
    getError (field) {
      if (this.errorExist(field)) {
        return this.errors[field].join(', ')
      }
      return ''
    },
    errorExist (field) {
      return !!(this.errors && this.errors[field])
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/stylesheets/vars';

  .my-field {
    margin-bottom: 1rem;
    position: relative;
    /deep/ .pcg-input-label {
      margin-bottom: 0.25rem;
      color: $pcg-gray;
    }
  }

  .back-list {
    margin-left: 1rem;
    font-size: $font-size-m;
    color: $main-active-color;
    font-weight: 400;
    a {
      color: unset
    }
  }
</style>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/vars-contrast";
  .contrast {
    .my-field {
      /deep/ .pcg-input-label {
        color: $pcg-gray;
      }
    }
    .back-list {
      color: $main-active-color;
    }
  }
</style>
